import { generateObjectChanges } from '@hm/core/functions/generate-object-changes.function';

import { GuaranteeApplication } from '@lib/core/models/guarantee-application.interface';
import { PagedResponse } from '@lib/core/models/paged-response';
import { Prescription, PrescriptionHistoryStatus } from '@lib/core/models/prescription.interface';

export function generateHistoricalPrescriptionsByDate(pagedResponse: PagedResponse<GuaranteeApplication>) {
  return pagedResponse.value.map(guarantee => {
    const prescriptions: Prescription[] = [...guarantee.prescriptions];
    const activePrescriptions: Prescription[] = prescriptions
      .filter(p => p.historyStatus === PrescriptionHistoryStatus.Active)
      .map(prescription => {
        const historicalPrescriptions: Prescription[] = prescriptions.filter(p => p.originalPrescriptionId === prescription.originalPrescriptionId);
        return {
          ...prescription,
          historicalChanges: generateObjectChanges(historicalPrescriptions, 'lastUpdateDate'),
        };
      });
    return {
      ...guarantee,
      prescriptions: activePrescriptions,
    };
  });
}
